const AgentAvailabilityOfImportance = {
  l1Agent: "L1 Agent",
  l2Agent: "L2 Agent",
  billing: "BT Agent",
};

export default {
  AgentAvailabilityOfImportance,
};
